<input type="checkbox" (change)="onToggleAll($event)" />
